import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { useLocation } from "react-router-dom";

import useMainNavigationStore from "../stores/useMainNavigationStore";

const useMainNavigationMobileFullScreen = () => {
  const location = useLocation();

  const { setMobileFullScreen, closeDropdownMenu } = useMainNavigationStore(
    useShallow((state) => ({
      setMobileFullScreen: state.setMobileFullScreen,
      closeDropdownMenu: state.closeDropdownMenu,
    }))
  );

  // hide Mobile Full Screen mode on the every location change
  useEffect(() => {
    setMobileFullScreen(false);
    closeDropdownMenu();
  }, [location, setMobileFullScreen, closeDropdownMenu]);
};

export default useMainNavigationMobileFullScreen;
